export default "__VITE_ASSET__DcxduWId__"